import React from "react";
import { formatCount } from "./searchModes";

const plural = (count, one, many) => `${formatCount(count)} ${count === 1 ? one : many}`;

/**
 * Small plan/usage card shown under the AI criteria panels. The numbers come from the server's usage ledger
 * (GET api/Entitlements/me -> usage): AI searches this month, and beside them the follow-up questions, summaries and
 * reports. "of N" appears only when the subscription sets a monthly search quota.
 */
export default function AiUsageMeter({ entitlement }) {
  if (!entitlement || entitlement.unavailable) return null;
  const usage = entitlement.usage || {};
  const tenant = entitlement.tenant || {};
  const quota = usage.monthlySearchQuota;
  const used = Number(usage.searchesThisMonth) || 0;
  const assistant = Number(usage.assistantRequestsThisMonth) || 0;
  const metered = quota !== null && quota !== undefined && Number.isFinite(Number(quota)) && Number(quota) > 0;
  const percent = metered ? Math.min(100, Math.round((used / quota) * 100)) : 0;

  return (
    <div className="ds-usage" aria-label="DocumentSync AI plan">
      <div className="ds-usage-head">
        <span className="ds-usage-title">
          <span className="ds-ai-badge">AI</span> DocumentSync AI
        </span>
        {/* The tenant's name only when the server knows it (it is looked up once the seat gate is on). */}
        {entitlement.clientName && (
          <span className="ds-muted">
            {entitlement.clientName}
            {entitlement.enforced && tenant.status && tenant.status !== "Active" ? ` · ${tenant.status}` : ""}
          </span>
        )}
      </div>
      {metered && (
        <div className="ds-usage-bar" role="progressbar" aria-valuemin={0} aria-valuemax={quota} aria-valuenow={used}>
          <div className="ds-usage-fill" style={{ width: `${percent}%` }} />
        </div>
      )}
      <p className="ds-hint">
        {metered
          ? `${formatCount(used)} of ${formatCount(quota)} AI searches used this month`
          : `${plural(used, "AI search", "AI searches")} this month`}
        {` · ${plural(assistant, "assistant request", "assistant requests")}`}
      </p>
      {entitlement.enforced && tenant.seatLimit ? (
        <p className="ds-hint">
          {`${formatCount(tenant.seatsAssigned || 0)} of ${formatCount(tenant.seatLimit)} AI seats assigned`}
        </p>
      ) : null}
    </div>
  );
}
